export enum ModalType {
  Success = "success",
  Error = "error",
  Info = "info"
}
